// extracted by mini-css-extract-plugin
module.exports = {"text":"heroSkins-mediumOnConfined-text-bc79e8d2"};